"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var icons_material_1 = require("@mui/icons-material");
var material_1 = require("@mui/material");
var window_size_1 = require("@react-hook/window-size");
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var react_toastify_1 = require("react-toastify");
var components_1 = require("../../components");
var DrawerComponent_1 = __importDefault(require("../../components/DrawerComponent"));
var constants_1 = require("../../constants");
var context_1 = require("../../context");
var hooks_1 = require("../../hooks");
var models_1 = require("../../models");
var services_1 = require("../../services");
var translations_1 = require("../../translations");
var utilities_1 = require("../../utilities");
var ButtomComponent_1 = __importDefault(require("../../components/Form/ButtomComponent"));
var react_query_1 = require("react-query");
var useMutationDownloadTemplateForUploadClients_1 = require("../../hooks/mutations/useMutationDownloadTemplateForUploadClients");
var DrawerUploadClientsOfCampaignContainer = function (_a) {
    var _b, _c, _d;
    var onClose = _a.onClose, rest = __rest(_a, ["onClose"]);
    var widthSize = (0, window_size_1.useWindowWidth)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _e = (0, react_router_dom_1.useSearchParams)(), query = _e[0], setQuery = _e[1];
    var _f = (0, context_1.useGlobalLoading)(), updateLoading = _f.updateLoading, updateLoadingDescription = _f.updateLoadingDescription, resetLoading = _f.resetLoading;
    var campaignDetail = (0, hooks_1.useGlobalState)(constants_1.GET_DETAIL_CAMPAIGN)[0];
    var steps = 3;
    var _g = react_1.default.useState(utilities_1.ArrayHelper.generateArray(steps).map(function (_) { return ({ isCompleted: false }); })), completes = _g[0], setCompletes = _g[1];
    var _h = react_1.default.useState((_b = campaignDetail === null || campaignDetail === void 0 ? void 0 : campaignDetail.status) !== null && _b !== void 0 ? _b : models_1.EnumCampaignStatus.PENDING_UPLOAD_FILE_OF_CLIENTS), campaignStatus = _h[0], setCampaignStatus = _h[1];
    var handleStepCompleted = function (index) {
        var completed = __spreadArray([], completes, true);
        var arrayNumber = Array.isArray(index) ? index : [index];
        arrayNumber.forEach(function (number) {
            completed[number].isCompleted = true;
        });
        setCompletes(completed);
    };
    var handleChangeFileUploadClients = function (ev) { return __awaiter(void 0, void 0, void 0, function () {
        var file, formData, response, error_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    updateLoading(true);
                    if (!((_a = ev.target) === null || _a === void 0 ? void 0 : _a.files)) return [3 /*break*/, 4];
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    file = (_b = ev.target) === null || _b === void 0 ? void 0 : _b.files[0];
                    formData = new FormData();
                    formData.append('file', file);
                    return [4 /*yield*/, services_1.api.post("/api/v1/admin/campaigns/".concat(campaignDetail === null || campaignDetail === void 0 ? void 0 : campaignDetail.id, "/upload-clients"), formData, {
                            headers: {
                                'Content-Type': 'multipart/form-data',
                            },
                            onUploadProgress: function (event) {
                                var _a;
                                var percentaje = Math.round((100 * event.loaded) / ((_a = event === null || event === void 0 ? void 0 : event.total) !== null && _a !== void 0 ? _a : 0));
                                updateLoadingDescription("Subiendo archivo: ".concat(percentaje, "%"));
                                if (percentaje === 100) {
                                    resetLoading();
                                }
                            },
                        })];
                case 2:
                    response = _c.sent();
                    updateLoading(true);
                    updateLoadingDescription('Procesando subida, por favor espere...');
                    if (response.data) {
                        setCampaignStatus(models_1.EnumCampaignStatus.IN_PROGRESS_UPLOAD_FILE_OF_CLIENTS);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _c.sent();
                    resetLoading();
                    (0, utilities_1.handleError)(error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var _j = (0, react_query_1.useQuery)([campaignDetail === null || campaignDetail === void 0 ? void 0 : campaignDetail.id, 'verify-done-upload-client-to-send-assign-card'], function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, services_1.api.get("/api/v1/admin/campaigns/".concat(campaignDetail === null || campaignDetail === void 0 ? void 0 : campaignDetail.id, "/verify-status-of-campaign-to-assign-card"))];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data];
            }
        });
    }); }, {
        enabled: !!campaignStatus &&
            campaignStatus ===
                models_1.EnumCampaignStatus.IN_PROGRESS_UPLOAD_FILE_OF_CLIENTS,
        refetchInterval: 3000,
        refetchIntervalInBackground: true,
        onSuccess: function (data) {
            var statusCode = data.statusCode;
            var message = data.message;
            var status = data.status;
            if (statusCode === 400) {
                react_toastify_1.toast.warning(message + ' Contactarse con el soporte técnico');
                resetLoading();
            }
            if (status === models_1.EnumCampaignStatus.PENDING_ASSIGN_CARD) {
                react_toastify_1.toast.success('Los clientes se subieron con éxito');
                resetLoading();
                handleStepCompleted(0);
            }
            setCampaignStatus(status);
        },
        onError: function (error) {
            resetLoading();
            (0, utilities_1.handleError)(error);
        },
    });
    var handleAssignCardToClients = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!completes[0].isCompleted) {
                        react_toastify_1.toast.warning('Paso 1: No se subieron los clientes.');
                        return [2 /*return*/];
                    }
                    updateLoading(true);
                    updateLoadingDescription('Asociando tarjetas, por favor espere...');
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, services_1.api.post("/api/v1/admin/campaigns/".concat(campaignDetail === null || campaignDetail === void 0 ? void 0 : campaignDetail.id, "/assign-cards"))];
                case 2:
                    response = _a.sent();
                    if (response.data) {
                        setCampaignStatus(models_1.EnumCampaignStatus.IN_PROGRESS_ASSIGN_CARD);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    resetLoading();
                    (0, utilities_1.handleError)(error_2);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var _k = (0, react_query_1.useQuery)([campaignDetail === null || campaignDetail === void 0 ? void 0 : campaignDetail.id, 'verify-done-assign-cards-to-recharge'], function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, services_1.api.get("/api/v1/admin/campaigns/".concat(campaignDetail === null || campaignDetail === void 0 ? void 0 : campaignDetail.id, "/verify-status-of-assign-cards-to-recharge"))];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data];
            }
        });
    }); }, {
        enabled: !!campaignStatus &&
            (campaignStatus === models_1.EnumCampaignStatus.IN_PROGRESS_ASSIGN_CARD ||
                campaignStatus === models_1.EnumCampaignStatus.PENDING_ASSIGN_CARD ||
                campaignStatus === models_1.EnumCampaignStatus.FAIL_ASSIGNED_CARDS),
        refetchInterval: 3000,
        refetchIntervalInBackground: true,
        onSuccess: function (data) {
            var statusCode = data.statusCode;
            var message = data.message;
            var status = data.status;
            if (statusCode === 400) {
                react_toastify_1.toast.warning(message + ' Contactarse con el soporte técnico');
                setCampaignStatus(models_1.EnumCampaignStatus.FAIL_PROCESSING_CLIENTS);
                resetLoading();
            }
            if (status === models_1.EnumCampaignStatus.SUCCESS_ASSIGNED_CARDS) {
                react_toastify_1.toast.success('Se asociaron las tarjetas con éxito');
                resetLoading();
                setCampaignStatus(status);
                handleStepCompleted(1);
            }
            if (status === models_1.EnumCampaignStatus.FAIL_ASSIGNED_CARDS) {
                react_toastify_1.toast.success('Ocurrió un error al asignar tarjetas.');
                resetLoading();
                setCampaignStatus(status);
            }
        },
        onError: function (error) {
            resetLoading();
            (0, utilities_1.handleError)(error);
        },
    });
    var handleRechargeCardToClients = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!completes[1].isCompleted) {
                        react_toastify_1.toast.warning('Paso 2: No se asociaron las tarjetas los clientes.');
                        return [2 /*return*/];
                    }
                    updateLoading(true);
                    updateLoadingDescription('Recargando las tarjetas, por favor espere...');
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, services_1.api.post("/api/v1/admin/campaigns/".concat(campaignDetail === null || campaignDetail === void 0 ? void 0 : campaignDetail.id, "/recharge-balances"))];
                case 2:
                    response = _a.sent();
                    if (response.data) {
                        setCampaignStatus(models_1.EnumCampaignStatus.PENDING_RECHARGE_BALANCES);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_3 = _a.sent();
                    resetLoading();
                    (0, utilities_1.handleError)(error_3);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var _l = (0, react_query_1.useQuery)([campaignDetail === null || campaignDetail === void 0 ? void 0 : campaignDetail.id, 'verify-status-recharge-balances'], function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, services_1.api.get("/api/v1/admin/campaigns/".concat(campaignDetail === null || campaignDetail === void 0 ? void 0 : campaignDetail.id, "/verify-status-recharge-balances"))];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data];
            }
        });
    }); }, {
        enabled: !!campaignStatus &&
            (campaignStatus === models_1.EnumCampaignStatus.PENDING_RECHARGE_BALANCES ||
                campaignStatus === models_1.EnumCampaignStatus.FAIL_RECHARGE_BALANCES),
        refetchInterval: 3000,
        refetchIntervalInBackground: true,
        onSuccess: function (data) {
            var statusCode = data.statusCode;
            var message = data.message;
            var status = data.status;
            if (statusCode === 400) {
                // toast.warning(message + ' Contactarse con el soporte técnico');
                setCampaignStatus(models_1.EnumCampaignStatus.FAIL_RECHARGE_BALANCES);
                return;
            }
            if (status === models_1.EnumCampaignStatus.PENDING_RECHARGE_BALANCES) {
                setCampaignStatus(status);
                return;
            }
            if (status === models_1.EnumCampaignStatus.PENDING_SEND_EMAIL) {
                setCampaignStatus(status);
                handleStepCompleted(2);
                resetLoading();
                react_toastify_1.toast.success('Se recargaron las tarjetas con éxito');
                return;
            }
            if (status === models_1.EnumCampaignStatus.FAIL_RECHARGE_BALANCES) {
                setCampaignStatus(status);
                // toast.warning('Falló la recarga de tarjetas.');
                resetLoading();
                return;
            }
        },
        onError: function (error) {
            resetLoading();
            (0, utilities_1.handleError)(error);
        },
    });
    var handleCompleted = function () {
        services_1.queryClient.invalidateQueries(constants_1.GET_ALL_CAMPAIGNS_FOR_ADMIN);
        onClose();
        navigate('/admin/campaigns');
        query.delete('campaignIdentifier');
        setQuery(query);
    };
    (0, react_1.useEffect)(function () {
        if (!!(campaignDetail === null || campaignDetail === void 0 ? void 0 : campaignDetail.status)) {
            if ([
                models_1.EnumCampaignStatus.IN_PROGRESS_ASSIGN_CARD,
                models_1.EnumCampaignStatus.FAIL_ASSIGNED_CARDS,
                models_1.EnumCampaignStatus.SUCCESS_ASSIGNED_CARDS,
                models_1.EnumCampaignStatus.PENDING_ASSIGN_CARD,
            ].includes(campaignDetail === null || campaignDetail === void 0 ? void 0 : campaignDetail.status)) {
                handleStepCompleted(0);
            }
            if ([
                models_1.EnumCampaignStatus.PENDING_RECHARGE_BALANCES,
                models_1.EnumCampaignStatus.FAIL_RECHARGE_BALANCES,
                models_1.EnumCampaignStatus.PENDING_SEND_EMAIL,
                models_1.EnumCampaignStatus.SUCCESS_ASSIGNED_CARDS,
            ].includes(campaignDetail === null || campaignDetail === void 0 ? void 0 : campaignDetail.status)) {
                handleStepCompleted([0, 1]);
            }
        }
    }, [campaignDetail === null || campaignDetail === void 0 ? void 0 : campaignDetail.status]);
    var mutationDownloadTemplate = (0, useMutationDownloadTemplateForUploadClients_1.useMutationDownloadTemplateForUploadClients)();
    var mutationRetryRechargeBalanceAllCards = (0, react_query_1.useMutation)(function () {
        return services_1.api.post("/api/v1/admin/campaigns/".concat(campaignDetail === null || campaignDetail === void 0 ? void 0 : campaignDetail.id, "/retry-recharge-balances"));
    }, {
        onSuccess: function () {
            updateLoading(true);
            setTimeout(function () {
                setCampaignStatus(models_1.EnumCampaignStatus.PENDING_RECHARGE_BALANCES);
            }, 3000);
            updateLoadingDescription('Procesando recarga, por favor espere...');
        },
    });
    return ((0, jsx_runtime_1.jsxs)(DrawerComponent_1.default, __assign({ anchor: 'right', onClose: onClose, width: widthSize }, rest, { children: [(0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: '10px',
                    marginBottom: '10px',
                    flexWrap: 'wrap',
                } }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "flex", gap: "10px", alignItems: "center" }, { children: [(0, jsx_runtime_1.jsx)(material_1.IconButton, __assign({ onClick: onClose }, { children: (0, jsx_runtime_1.jsx)(icons_material_1.Close, { fontSize: "inherit" }) })), (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "h6", component: 'h6' }, { children: "Cargar Clientes" }))] })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ display: "flex", gap: "10px", alignItems: "center" }, { children: (0, jsx_runtime_1.jsx)(ButtomComponent_1.default, __assign({ variant: "contained", onClick: function () { return mutationDownloadTemplate.mutate(); } }, { children: "Descargar Plantilla" })) }))] })), (0, jsx_runtime_1.jsx)(material_1.Divider, {}), (0, jsx_runtime_1.jsxs)(material_1.Paper, __assign({ elevation: 0, sx: { marginTop: '20px' } }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Typography, __assign({ variant: "h6", fontWeight: "bold", sx: { marginBottom: '20px' } }, { children: ["Campa\u00F1a ", campaignDetail === null || campaignDetail === void 0 ? void 0 : campaignDetail.description] })), (0, jsx_runtime_1.jsx)(components_1.StepperComponent, { activeStep: [
                            models_1.EnumCampaignStatus.IN_PROGRESS_ASSIGN_CARD,
                            models_1.EnumCampaignStatus.FAIL_ASSIGNED_CARDS,
                            models_1.EnumCampaignStatus.SUCCESS_ASSIGNED_CARDS,
                            models_1.EnumCampaignStatus.PENDING_ASSIGN_CARD,
                        ].includes((_c = campaignDetail === null || campaignDetail === void 0 ? void 0 : campaignDetail.status) !== null && _c !== void 0 ? _c : models_1.EnumCampaignStatus.IN_PROGRESS_UPLOAD_FILE_OF_CLIENTS)
                            ? 1
                            : [
                                models_1.EnumCampaignStatus.PENDING_RECHARGE_BALANCES,
                                models_1.EnumCampaignStatus.FAIL_RECHARGE_BALANCES,
                                models_1.EnumCampaignStatus.PENDING_SEND_EMAIL,
                            ].includes((_d = campaignDetail === null || campaignDetail === void 0 ? void 0 : campaignDetail.status) !== null && _d !== void 0 ? _d : models_1.EnumCampaignStatus.IN_PROGRESS_UPLOAD_FILE_OF_CLIENTS)
                                ? 2
                                : 0, stepCompletes: completes, handleCompleted: handleCompleted, notBackButton: true, steps: [
                            {
                                title: 'Cargar clientes',
                                renderContent: function (index) { return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [campaignStatus ===
                                            models_1.EnumCampaignStatus.PENDING_UPLOAD_FILE_OF_CLIENTS && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ sx: { mt: 2, mb: 1 } }, { children: "Selecciona el archivo Excel, con los datos de tus clientes." })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: { marginTop: '20px' } }, { children: (0, jsx_runtime_1.jsxs)(material_1.Button, __assign({ variant: "contained", color: "secondary", component: "label" }, { children: [(0, jsx_runtime_1.jsx)(icons_material_1.UploadFile, {}), (0, jsx_runtime_1.jsx)("span", { children: "Cargar clientes" }), (0, jsx_runtime_1.jsx)("input", { hidden: true, accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", type: "file", onChange: handleChangeFileUploadClients })] })) }))] })), campaignStatus !==
                                            models_1.EnumCampaignStatus.PENDING_UPLOAD_FILE_OF_CLIENTS && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ sx: { mt: 2, mb: 1 }, fontWeight: "bold" }, { children: "Resultado de estado de subida de clientes" })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: { marginTop: '20px' } }, { children: (0, jsx_runtime_1.jsx)(material_1.Alert, __assign({ color: completes[0].isCompleted ? 'success' : 'error' }, { children: translations_1.localeEs['status'][campaignStatus] })) }))] }))] })); },
                            },
                            {
                                title: 'Asociar tarjetas',
                                renderContent: function (index) { return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [campaignStatus ===
                                            models_1.EnumCampaignStatus.PENDING_ASSIGN_CARD && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ sx: { mt: 2, mb: 1 } }, { children: "Asociar las tarjetas a los clientes." })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: { marginTop: '20px' } }, { children: (0, jsx_runtime_1.jsx)(material_1.Button, __assign({ variant: "contained", color: "secondary", onClick: handleAssignCardToClients }, { children: (0, jsx_runtime_1.jsx)("span", { children: "Asociar tarjetas" }) })) }))] })), campaignStatus !==
                                            models_1.EnumCampaignStatus.PENDING_ASSIGN_CARD && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ sx: { mt: 2, mb: 1 }, fontWeight: "bold" }, { children: "Resultado de estado de asociar tarjetas a los clientes" })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: { marginTop: '20px' } }, { children: (0, jsx_runtime_1.jsx)(material_1.Alert, __assign({ color: campaignStatus ===
                                                            models_1.EnumCampaignStatus.FAIL_ASSIGNED_CARDS
                                                            ? 'error'
                                                            : campaignStatus ===
                                                                models_1.EnumCampaignStatus.IN_PROGRESS_ASSIGN_CARD
                                                                ? 'warning'
                                                                : 'success' }, { children: translations_1.localeEs['status'][campaignStatus] })) }))] }))] })); },
                            },
                            {
                                title: 'Recargar tarjetas',
                                renderContent: function (index) { return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [campaignStatus ===
                                            models_1.EnumCampaignStatus.SUCCESS_ASSIGNED_CARDS ||
                                            campaignStatus ===
                                                models_1.EnumCampaignStatus.PENDING_RECHARGE_BALANCES ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ sx: { mt: 2, mb: 1 } }, { children: "Recarga las tarjetas de los clientes." })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: { marginTop: '20px' } }, { children: (0, jsx_runtime_1.jsx)(material_1.Button, __assign({ variant: "contained", color: "secondary", onClick: handleRechargeCardToClients }, { children: (0, jsx_runtime_1.jsx)("span", { children: "Recargar tarjetas" }) })) }))] })) : null, campaignStatus ===
                                            models_1.EnumCampaignStatus.FAIL_RECHARGE_BALANCES ? ((0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ alignItems: "center" }, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ sx: { mt: 2, mb: 1 }, fontWeight: "bold" }, { children: "Resultado de estado de recarga de tarjetas" })), (0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ sx: { marginTop: '20px' }, alignItems: "center" }, { children: [(0, jsx_runtime_1.jsx)(material_1.Alert, __assign({ color: translations_1.localeEs['color'][campaignStatus] }, { children: translations_1.localeEs['status'][campaignStatus] })), campaignStatus ===
                                                            models_1.EnumCampaignStatus.FAIL_RECHARGE_BALANCES && ((0, jsx_runtime_1.jsx)(material_1.Button, __assign({ sx: { mt: 3 }, onClick: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                                                                switch (_a.label) {
                                                                    case 0: return [4 /*yield*/, mutationRetryRechargeBalanceAllCards.mutateAsync()];
                                                                    case 1: return [2 /*return*/, _a.sent()];
                                                                }
                                                            }); }); } }, { children: "Volver a procesar las recargas" })))] }))] }))) : null, campaignStatus === models_1.EnumCampaignStatus.PENDING_SEND_EMAIL ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ sx: { mt: 2, mb: 1 }, fontWeight: "bold" }, { children: "Resultado de estado de recarga de tarjetas" })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: { marginTop: '20px' } }, { children: (0, jsx_runtime_1.jsx)(material_1.Alert, __assign({ color: "success" }, { children: translations_1.localeEs['status'][models_1.EnumCampaignStatus.PENDING_SEND_EMAIL] })) }))] })) : null] })); },
                            },
                        ] })] }))] })));
};
exports.default = DrawerUploadClientsOfCampaignContainer;
